<template>
  <div class="product-card" :style="cssVars">
    <h1 v-html="productCategory"></h1>
    <div class="content">
      <div class="product-brand">
        <h2>{{ product.brand && product.brand.name }}</h2>
        <img
          :src="product.brand.logo"
          v-if="product.brand && product.brand.logo"
        />
      </div>
      <div
        class="product-name"
        :style="{
          'align-items':
            (product.name && product.name.length) > 55 ? '' : ''
        }"
      >
        {{ product.name }}
      </div>
      <div class="category-variant-container">
        <div class="product-variant">
          <span v-for="(size, index) in sizes" :key="index">
            <span>{{ size }}</span>
            <template v-if="sizes.length !== index + 1"> / </template>
          </span>
        </div>
        <div class="category-container">
          <span class="product-category">{{
            product.cannabis_attributes && product.cannabis_attributes.plant_type
          }}</span>
        </div>
      </div>
      <div class="data">
        <div class="thc">
          <div class="data-title gap-b-16">THC</div>
          <div class="value">
            {{ product.thc_cbd_levels && product.thc_cbd_levels.thc_min }}
            -
            {{ product.thc_cbd_levels && product.thc_cbd_levels.thc_max }}
            {{
              product.thc_cbd_levels &&
                product.thc_cbd_levels.concentration_unit
            }}
          </div>
          <!-- <div class="active-value">
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['low', 'medium', 'high'].includes(
                    product.thc_cbd_levels.thc_level
                  )
              }"
            ></span>
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['medium', 'high'].includes(product.thc_cbd_levels.thc_level)
              }"
            ></span>
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['high'].includes(product.thc_cbd_levels.thc_level)
              }"
            ></span>
          </div> -->
        </div>
        <div class="cbd">
          <div class="data-title gap-b-16">CBD</div>
          <div class="value">
            {{ product.thc_cbd_levels && product.thc_cbd_levels.cbd_min }}
            -
            {{ product.thc_cbd_levels && product.thc_cbd_levels.cbd_max }}
            {{
              product.thc_cbd_levels &&
                product.thc_cbd_levels.concentration_unit
            }}
          </div>
          <!-- <div class="active-value">
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['low', 'medium', 'high'].includes(
                    product.thc_cbd_levels.cbd_level
                  )
              }"
            ></span>
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['medium', 'high'].includes(product.thc_cbd_levels.cbd_level)
              }"
            ></span>
            <span
              :class="{
                active:
                  product.thc_cbd_levels &&
                  ['high'].includes(product.thc_cbd_levels.cbd_level)
              }"
            ></span>
          </div> -->
        </div>
        <!-- <div class="aromas">
          <div class="data-title">Aromas</div>
          <div class="na-value" v-if="productAromas.length === 0">N/A</div>
          <div class="images" v-else>
            <template v-for="aroma in aromas">
              <div
                class="svg-div"
                :key="aroma.name"
                v-if="productAromas.slice(0, 3).includes(aroma.name)"
                v-html="svgIcons[aroma.name.toLowerCase()]"
              ></div>
            </template>
          </div>
        </div> -->
      </div>
      <div class="qr-content">
        <div class="qr-title gap-b-16">
          <div>MORE INFO</div>
          <div>PRICE</div>
        </div>
        <div class="details">
          <div class="qr-container">
            <qrcode-vue :value="qrCodeValue" :size="vg_productSelectionType === 'image' ? 79*scale: 79 * scale" />
            <img :src="logo" :height="vg_productSelectionType === 'image'? this.scale*20 : this.scale*20" width="vg_productSelectionType === 'image' ? this.scale*20: this.scale*20" class="qrcode-image" />
          </div>
          <div class="price">
            <!-- <div class="price-items"> -->
              ${{ price && price >= 0 ? price.toFixed(2) : 'N/A' }}
              <!-- <div class="value">
              </div> -->
              <!-- <div class="price-hr"></div> -->
              <!-- <div class="variant-weights">
                <span v-for="(size, index) in sizes" :key="index">
                  <span>{{ size }}</span>
                  <template v-if="sizes.length !== index + 1"> / </template>
                </span>
              </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Bottom Left -->
      <div
        style="border-left: 1px solid grey; height: 22px; position: absolute; bottom: 0px; left: 34px;"
      ></div>
      <div
        style="border-top: 1px solid grey; width: 22px; position: absolute; bottom: 34px; left: 0px;"
      ></div>

      <!-- Bottom Right -->
      <div
        style="border-left: 1px solid grey; height: 22px; position: absolute; bottom: 0px; right: 34px;"
      ></div>
      <div
        style="border-top: 1px solid grey; width: 22px; position: absolute; bottom: 34px; right: 0px;"
      ></div>

      <!-- Top Left -->
      <div
        style="border-left: 1px solid grey; height: 22px; position: absolute; top: 0px; left: 34px;"
      ></div>
      <div
        style="border-top: 1px solid grey; width: 22px; position: absolute; top: 34px; left: 0px;"
      ></div>

      <!-- Top Right -->
      <div
        style="border-left: 1px solid grey; height: 22px; position: absolute; top: 0px; right: 34px;"
      ></div>
      <div
        style="border-top: 1px solid grey; width: 22px; position: absolute; top: 34px; right: 0px"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import svgIcons from './icons'
import QrcodeVue from 'qrcode.vue'

const prod = {
  name: 'n/a',
  description: 'n/a',
  sku: 'n/a',
  image: 'n/a',
  product_type: 'n/a',
  product_family: 'n/a',
  weighing_unit: 'g',
  brand: {
    name: 'No Brand',
    logo: '',
    description: ''
  },
  category: {
    name: 'Pre-Roll',
    description: '',
    featured: false
  },
  aromas: [
    {
      name: 'Skunky',
      description: 'n/a',
      image: null
    }
  ],
  thc_cbd_levels: {
    thc_level: 'high',
    thc: 0,
    thc_min: 0,
    thc_max: 0,
    cbd_level: 'low',
    cbd: 0,
    cbd_min: 0,
    cbd_max: 0,
    concentration_unit: '%'
  },
  variants: []
}

export default {
  props: {
    product: {
      type: Object,
      default() {
        return prod
      }
    },
    isPdf: {
      type: Boolean,
      default() {
        return false
      }
    },
    qrCodeValue: {
      type: String,
      default() {
        return ''
      }
    },
    borders: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  components: {
    QrcodeVue
  },
  data() {
    return {
      logo: require('@/assets/images/Rectangle.jpg'),
      aromas: [
        { name: 'Cheesy' },
        { name: 'Citrusy' },
        { name: 'Earthy' },
        { name: 'Floral' },
        { name: 'Fruity' },
        { name: 'Herbal' },
        { name: 'Skunky' },
        { name: 'Spicy' },
        { name: 'Sweet' }
      ],
      svgIcons: svgIcons,
      loaded: true,
      price: null,
      sizes: [],
      weighing_unit: 'gms',
      scale: 2
    }
  },
  mounted() {
    this.computePriceAndSize(this.product)
    if (this.vg_productSelectionType === 'image') {
      this.scale = 8
    }
  },
  watch: {
    product(val) {
      this.computePriceAndSize(val)
    }
  },
  computed: {
    productCategory() {
      if (this.product.category && this.product.category.name) {
        return this.product.category.name
          .split(' ')
          .map(
            s =>
              `<span style="font-size: ${17 * this.scale}px;">${s.substring(0, 1)}</span><span>${s.substring(1)}</span>`
          )
          .join(' ')
      }
      return `<span style="font-size: ${17 * this.scale}px;">F</span></span>eatured</span> <span style="font-size: ${17 *
        this.scale}px;">P</span>roducts</span>`
    },
    cssVars() {
      return {
        '--scale': `${this.scale}px`,
        '--product-brand-font': `${4.8 * this.scale}px`,
        '--product-card-width': `${258 * this.scale}px`,
        '--product-card-height': `${390 * this.scale}px`,
        '--product-card-h1-font-size': `${13 * this.scale}px`,
        '--product-card-h1-first-font-size': `${17 * this.scale}px`,
        '--product-card-h1-first-letter-font-size': `${17 * this.scale}px`,
        '--product-card-price-font': `${28 * this.scale}px`,
        '--product-price-div-height': `${80 * this.scale}px`,
        '--thc-content-width': `${42 * this.scale}px`,
        '--thc-cbd-font-size': `${14.5 * this.scale}px`,
        '--thc-active-width': `${14.5 * this.scale}px`,
        '--thc-active-height': `${4.5 * this.scale}px`,
        '--thc-data-title-font': `${9 * this.scale}px`,
        '--product-category-height': `${17.5 * this.scale}px`,
        '--product-category-font': `${11 * this.scale}px`,
        '--product-name-font': `${19 * this.scale}px`,
        '--variant-weights-font': `${10 * this.scale}px`,
        '--hr-margin': this.isPdf ? '0px 0px' : '12px 0px',
        '--price-width': this.vg_productSelectionType === 'image' ? '50%' : '67%',
        '--price-margin': this.vg_productSelectionType === 'image' ? `${10 * this.scale}px` : '0px',
        '--price-item-width': this.vg_productSelectionType === 'image' ? '90%' : 'fit-content'
      }
    },
    productAromas() {
      return this.product.aromas ? this.product.aromas.map(o => o.name) : []
    },
    background() {
      return this.vg_activeBusinessBrandingAndLogo.primary
    },
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
      productObj: 'locationproduct/productObj',
      getAromas: 'aroma/list',
      vg_productSelectionType: 'locationproduct/productSelectionType'
    })
  },
  methods: {
    computePriceAndSize(product) {
      let allPrices = []
      let allSizes = []
      if (Array.isArray(product.variants)) {
        this.product.variants.map(variant => {
          allPrices.push(variant.price)
          if (variant.size && variant.size !== '') {
            allSizes.push(variant.size)
          }
        })
      }
      this.price = Math.min(...allPrices)
      if (allPrices.length === 0) this.price = 'n/a'
      this.sizes = [...new Set(allSizes)]
    },
    downloadPDF() {
      this.loaded = false
      this.$refs.html2Pdf.generatePdf()
    }
  }
}
</script>

<style scoped lang="scss">
.v-card__text {
  padding: 0px;
}

.product-card {
  width: var(--product-card-width);
  height: var(--product-card-height);
  border: 1px solid rgb(156, 156, 156);
  position: relative;
  // padding-top: 4%;
  background: #fff;
  font-family: 'Zoom-Pro-Narrow-Medium';

  & > img {
    position: absolute;
    width: calc(var(--scale) * 32);
  }

  h1 {
    color: #fff;
    background: var(--v-primary-base);
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: calc(var(--scale) * 3);
    text-align: center;
    width: 100%;
    height: 10%;
    text-transform: uppercase;
    font-family: 'AlegreyaSC-Medium';
    font-size: var(--product-card-h1-font-size);
    margin-right: auto;
    margin-left: auto;
    font-weight: 500;
    letter-spacing: 0.075em;
  }

  .content {
    padding: 9% 12%;
    overflow-x: hidden;

    .product-brand {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: calc(var(--scale) * 15);
      font-size: var(--product-brand-font);

      h2 {
        text-transform: uppercase;
        font-family: 'AlegreyaSC-Light';
        font-weight: 800;
        letter-spacing: 0.1em;
      }

      img {
        width: calc(var(--scale) * 15);
        object-fit: contain;
      }
    }

    .product-name {
      font-weight: bolder;
      text-transform: uppercase;
      font-size: var(--product-name-font);
      line-height: var(--product-name-font);
      width: 100%;
      margin-bottom: calc(var(--scale) * 12); // 12
      padding-top: calc(var(--scale) * 7); // 7
      color: #2d2a26;
      font-family: 'BebasNeue-Bold';
      height: 4em;
      overflow-y: hidden;
      display: flex;
      // vertical-align: text-top;
    }
    .category-variant-container {
      display: grid;
      grid-template-columns: 2fr 1fr;
      .category-container {
        text-align: right;
      }
      .product-variant span {
        font-family: 'AlegreyaSC-Black';
        font-size: var(--variant-weights-font);
        text-transform: uppercase;
        color: var(--v-primary-base);
      }
    }

    .product-category {
      font-weight: 600;
      font-size: var(--product-category-font);
      color: white;
      background: var(--v-primary-base);
      padding: calc(var(--scale) * 4) calc(var(--scale) * 6);
      text-transform: uppercase;
      font-family: 'AlegreyaSC-Black';
      letter-spacing: 0.08em;
      border-radius: calc(var(--scale) * 2);
    }

    .data {
      overflow-x: hidden;
      margin: calc(var(--scale) * 24) 0 calc(var(--scale) * 16);
      color: var(--v-primary-base);
      display: grid;
      grid-template-columns: auto auto;

      & > div {
        overflow: hidden;
      }

      .thc {
        width: fit-content;

        .value {
          font-size: var(--thc-cbd-font-size);
          font-weight: bold;
          font-family: 'BebasNeue-Bold';
          letter-spacing: 0.05em;
        }
      }

      .cbd {
        width: fit-content;

        .value {
          font-size: var(--thc-cbd-font-size);
          font-weight: bold;
          font-family: 'BebasNeue-bold';
          letter-spacing: 0.05em;
        }
      }

      .aromas {
        // width: fit-content;
        display: grid;
        grid-template-columns: 1fr 1fr;
        // flex-direction: column;
        // justify-content: space-between;

        .images {
          display: flex;
        }

        .na-value {
          font-size: var(--thc-cbd-font-size);
          font-weight: bold;
          font-family: 'BebasNeue-Bold';
          letter-spacing: 0.05em;
        }

        .svg-div {
          width: calc(var(--scale) * 15);
          height: calc(var(--scale) * 15);
          border: 1px solid var(--v-primary-base);
          border-radius: 50%;
          padding: calc(var(--scale) * 2);
          margin-right: calc(var(--scale) * 2);

          svg {
            path {
              fill: var(--v-primary-base);
            }
          }
        }
      }

      .data-title {
        font-size: var(--thc-data-title-font);
        // margin-bottom: calc(var(--scale) * 1);
        text-transform: uppercase;
        font-family: 'AlegreyaSC-Medium';
        letter-spacing: 0.1em;
      }

      // span {
      //   display: block;
      //   background: rgb(208, 208, 208);
      //   width: var(--thc-active-width);
      //   height: var(--thc-active-height);
      //   border-radius: calc(var(--thc-active-height) / 2);
      //   margin-top: calc(var(--scale) * 2);

      //   &.active {
      //     background: var(--v-primary-base);
      //   }

      //   &:not(:last-child) {
      //     margin-right: calc(var(--scale) * 4);
      //   }
      // }

      // .active-value {
      //   display: flex;
      // }
    }

    .qr-content {
      margin-top: calc(var(--scale) * 13);

      .qr-title {
        display: grid;
        grid-template-columns: 1fr 1fr;

        & > div {
          font-size: var(--thc-data-title-font);
          font-family: 'AlegreyaSC-Medium';
          color: var(--v-primary-base);
          letter-spacing: 0.1rem;
        }
      }

      .details {
        // position: relative;
        margin-top: calc(var(--scale) * 6);
        // display: flex;
        // justify-content: space-between;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        text-align: center;
        color: var(--v-primary-base);
        // margin-right: var(--price-margin);

        .price {
          // width: var(--price-width);
          position: static;
          // right: calc(var(--scale) * -32);
          height: var(--product-price-div-height);
          display: flex;
          flex-direction: column;
          justify-content: center;
          background: #eff0eb;
          text-align: center;
          border-radius: calc(var(--scale) * 2);
          font-family: 'BebasNeue-Bold';
          font-weight: 800;
          font-size: var(--product-card-price-font);
          padding-top: calc(var(--scale) * 6);
          // padding-left: calc(var(--scale) * 15);

          // .price-items {
          //   // width: var(--price-item-width);
          //   font-size: var(--product-card-price-font);
          //   font-weight: 800;
          //   position: static;
          //   overflow: hidden;
          //   float:none;
          //   display: flex;
          //     // margin: var(--hr-margin);
          //   margin: auto;
          //   background-color: aquamarine;
          //   font-family: 'BebasNeue-Bold';

            // .price-hr {
            //   width: 100%;
            //   margin-left: 0px;
            //   margin-right: auto;
            //   background: var(--v-primary-base);
            //   height: calc(var(--scale) / 2);
            // }

            // .value {
            //   font-size: var(--product-card-price-font);
            //   font-weight: 800;
            //   // margin: var(--hr-margin);
            //   margin: auto;
            //   background-color: aquamarine;
            //   font-family: 'BebasNeue-Bold';
            // }

            // .variant-weights span {
            //   font-family: 'AlegreyaSC-Light';
            //   font-size: var(--variant-weights-font);

            //   &:first-child {
            //     font-family: 'AlegreyaSC-Bold';
            //   }
            // }
          // }
        }

        .qr-container {
          position: relative;
          justify-content: left;
          text-align: left;

          .qrcode-image {
            position: absolute;
            top: 38%;
            left: 33%;
          }
        }
      }
    }
  }
}
.custom-size{
    width:2064px;
     height:3268px;
     background:#fff
  }
  .gap-b-16{
    margin-bottom: 16px;
  }
</style>
